/**
 * Single dynamic import per page — shared by `React.lazy` and (optional) prefetch.
 * Avoids duplicate `import()` of the same chunk competing in Vite dev transform queue.
 */

export const importCatalogListPage = () =>
  import('../pages/catalog/CatalogListPage').then((m) => ({ default: m.CatalogListPage }));
export const importCatalogPage = () => import('../pages/CatalogPage');
export const importOrdersPage = () => import('../pages/OrdersPage');
export const importProcurementPage = () => import('../pages/ProcurementPage');
export const importHomePage = () => import('../pages/HomePage');
